import { formatDate } from '@angular/common';

/** The app's date format when the tenant's country does not provide one (matches the date pickers: DD-MM-YYYY). */
export const DEFAULT_DATE_PATTERN = 'dd-MM-yyyy';

let datePattern = DEFAULT_DATE_PATTERN;

/**
 * Turns a country's `dateFormat` (e.g. "DD/MM/YYYY", "dd-MM-yyyy") into an Angular date pattern.
 * Anything unusable falls back to the app default.
 */
export function toAngularDatePattern(format: string | null | undefined): string {
  const raw = (format || '').trim();
  if (!raw) return DEFAULT_DATE_PATTERN;
  const pattern = raw.replace(/Y/g, 'y').replace(/D/g, 'd');
  return /d/.test(pattern) && /M/.test(pattern) && /y/.test(pattern) ? pattern : DEFAULT_DATE_PATTERN;
}

export function setTenantDatePattern(format: string | null | undefined): void {
  datePattern = toAngularDatePattern(format);
}

export function tenantDatePattern(withTime = false): string {
  return withTime ? `${datePattern} h:mm a` : datePattern;
}

/**
 * Formats a date in the tenant's date format. Date-only strings (yyyy-MM-dd) are read as local dates so they do
 * not shift a day; unparseable input is returned as it came.
 */
export function formatTenantDate(value: string | number | Date | null | undefined, withTime = false): string {
  if (value === null || value === undefined || value === '') return '';
  let date: Date;
  if (value instanceof Date) {
    date = value;
  } else {
    const dateOnly = typeof value === 'string' ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(value) : null;
    date = dateOnly ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3])) : new Date(value);
  }
  if (isNaN(date.getTime())) return String(value);
  return formatDate(date, tenantDatePattern(withTime), 'en-US');
}

/** The tenant's date pattern in moment syntax (what the Material date pickers display and parse). */
export function tenantMomentPattern(): string {
  return datePattern.replace(/y/g, 'Y').replace(/d/g, 'D');
}
